import React, {Component} from 'react';
import {fromSystemDateTime, toHumanDateTime} from '../utils/date';
import TableHeading from './TableHeading';
import WinnerApprovalStatus from './WinnerApprovalStatus';
import BidsAlwaysEnabledWarning from './BidsAlwaysEnabledWarning';

export default class ReviewersTable extends Component {
    render() {
        const {accountHasSeparateBidReviews, reviewers, data, onCheckboxChecked} = this.props;

        if (reviewers.length === 0) {
            return null;
        }

        return (
            <div className="form-group">
                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover">
                        <TableHeading
                            accountHasSeparateBidReviews={accountHasSeparateBidReviews}
                        />
                        <tbody>
                        {
                            reviewers.map((item, index) => {
                                const bidsAlwaysEnabled = (item.bid_review_always_enabled === true);

                                let canAssessBids = false;
                                let canAssessWinner = false;
                                let winnerIsApproved = null;
                                let winnerNotes = '';
                                let winnerReviewedAt = null;
                                let canAssessStage1 = false;
                                let canAssessStage2 = false;
                                let canAssessStage3 = false;

                                if (data.hasOwnProperty(item.value)) {
                                    const element = data[item.value];

                                    canAssessBids = (element.can_assess_bids === true);
                                    canAssessWinner = (element.can_assess_winner === true);
                                    winnerIsApproved = element.winner_is_approved;
                                    winnerNotes = element.winner_notes || '';
                                    canAssessStage1 = (element.can_assess_stage1 === true);
                                    canAssessStage2 = (element.can_assess_stage2 === true);
                                    canAssessStage3 = (element.can_assess_stage3 === true);

                                    winnerReviewedAt = element.winner_reviewed_at;
                                    if (winnerReviewedAt) {
                                        winnerReviewedAt = toHumanDateTime(fromSystemDateTime(winnerReviewedAt));
                                    }
                                }

                                if (bidsAlwaysEnabled) {
                                    canAssessBids = true;
                                    canAssessStage1 = true;
                                    canAssessStage2 = true;
                                    canAssessStage3 = true;
                                }

                                return (
                                    <tr key={item.value}>
                                        <td style={{verticalAlign: 'middle'}}>{index + 1}</td>
                                        <td style={{verticalAlign: 'middle'}}>{item.label}</td>
                                        {
                                            accountHasSeparateBidReviews
                                                ? [
                                                    <td style={{verticalAlign: 'middle'}} key="can_assess_stage1">
                                                        <input type="checkbox"
                                                               value="1"
                                                               checked={canAssessStage1}
                                                               disabled={bidsAlwaysEnabled}
                                                               onChange={(e) => onCheckboxChecked(item.value, 'can_assess_stage1', e.target.checked)}
                                                        />
                                                        <BidsAlwaysEnabledWarning
                                                            show={bidsAlwaysEnabled}
                                                        />
                                                    </td>,
                                                    <td style={{verticalAlign: 'middle'}} key="can_assess_stage2">
                                                        <input type="checkbox"
                                                               value="1"
                                                               checked={canAssessStage2}
                                                               disabled={bidsAlwaysEnabled}
                                                               onChange={(e) => onCheckboxChecked(item.value, 'can_assess_stage2', e.target.checked)}
                                                        />
                                                        <BidsAlwaysEnabledWarning
                                                            show={bidsAlwaysEnabled}
                                                        />
                                                    </td>,
                                                    <td style={{verticalAlign: 'middle'}} key="can_assess_stage3">
                                                        <input type="checkbox"
                                                               value="1"
                                                               checked={canAssessStage3}
                                                               disabled={bidsAlwaysEnabled}
                                                               onChange={(e) => onCheckboxChecked(item.value, 'can_assess_stage3', e.target.checked)}
                                                        />
                                                        <BidsAlwaysEnabledWarning
                                                            show={bidsAlwaysEnabled}
                                                        />
                                                    </td>,
                                                ]
                                                : <td style={{verticalAlign: 'middle'}}>
                                                    <input type="checkbox"
                                                           value="1"
                                                           checked={canAssessBids}
                                                           disabled={bidsAlwaysEnabled}
                                                           onChange={(e) => onCheckboxChecked(item.value, 'can_assess_bids', e.target.checked)}/>

                                                    <BidsAlwaysEnabledWarning
                                                        show={bidsAlwaysEnabled}
                                                    />
                                                </td>
                                        }
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input type="checkbox"
                                                   value="1"
                                                   checked={canAssessWinner}
                                                   onChange={(e) => onCheckboxChecked(item.value, 'can_assess_winner', e.target.checked)}/>
                                        </td>
                                        <td>
                                            <WinnerApprovalStatus status={winnerIsApproved}/>
                                        </td>
                                        <td>{winnerNotes}</td>
                                        <td>{winnerReviewedAt}</td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
};